import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { colors, IStyles } from '../../../theme'

const previewTextStyles: IStyles = {
    wrapper: {
        ...grid.colCenter,
        ...grid.center,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    plate: {
        backgroundColor: colors.greyLight,
        width: '85%',
        maxHeight: '60vh',
        overflow: 'auto',
        padding: 24,
        borderRadius: 4,
        boxSizing: 'border-box',
    },
    plateVertical: {
        maxWidth: 520,
        maxHeight: '70vh',
    },
    content: {
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
    },
    previewQrCode: {
        ...grid.full,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
    },
}

addStyles(previewTextStyles)
export default previewTextStyles
